import useInterventionRepository from "../../../../../../repository/insurance/useInterventionRepository";
import useClientRepository from "../../../../../../repository/insurance/useClientRepository";
import {useEffect, useRef, useState} from "react";
import Box from "@mui/material/Box";
import {Button, InputAdornment, Link, Paper, Slide} from "@mui/material";
import {CalendarMonth, CheckCircle, Info} from "@mui/icons-material";
import {MobileDateTimePicker} from "@mui/x-date-pickers";
import {DemoItem} from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import Typography from "@mui/material/Typography";
import Body from "../../../../../../material/skeleton/Body";
import Footer from "../../../../../../material/skeleton/Footer";
import LoadingData from "../../../emergency/step/common/LoadingData";
import isNull from "../../../../../../mixin/isNull";
import Intervention from "../../../../../../entity/insurance/Intervention";
import useAlert from "../../../../../../use/useAlert";
import parameter from "../../../../../../enum/parameter";
import QuotationDetails from "../common/QuotationDetails";

const ERROR_APPOINTMENT_REQUIRED = "Veuillez renseigner le rendez-vous travaux.";

export default function ({interventionId, clientId}) {
    const alert = useAlert();
    const interventionRepository = useInterventionRepository();
    const clientRepository = useClientRepository();
    /** @type Client */
    const client = clientRepository.findOneById(clientId).select();
    const [loading, setLoading] = useState(false);
    const [appointmentSelected, setAppointmentSelected] = useState(false);
    const appointmentInput = useRef();
    const callLink = useRef();

    useEffect(() => {
        clientRepository.findOneById(clientId).exec();
    }, []);

    const handleAppointmentAccepted = val => {
        if (isNull(val)) return;

        appointmentInput.current = dayjs(val);

        setAppointmentSelected(true);
    }

    const nextStep = async () => {
        setLoading(true);

        if (isNull(appointmentInput.current)) {
            alert.warning(ERROR_APPOINTMENT_REQUIRED);
            setLoading(false);
            return;
        }

        const res = await interventionRepository.updateCurrentStep(interventionId, {
            intervention: {
                current_step: Intervention.STEP_WORKS_APPOINTMENT,
                works_appointment_at: appointmentInput.current.toISOString()
            }
        });

        if (!res) setLoading(false);
    }

    if (isNull(client)) return <LoadingData/>;

    return (
        <>
            <Body>
                <Box mt={2}>
                    <Slide direction={"left"} in={true} timeout={500}>
                        <Paper elevation={3}>
                            <Box
                                display="flex"
                                alignItems={"center"}
                                px={2}
                                py={1}
                            >
                                <Box display="flex" alignItems={"center"}>
                                    <Info color={"warning"}/>
                                </Box>
                                <Box ml={1}>
                                    <Typography>
                                        Convenez d'un rendez-vous avec le sociétaire afin de réaliser les
                                        travaux.
                                    </Typography>
                                </Box>
                            </Box>
                        </Paper>
                    </Slide>
                </Box>
                <Box px={2} mt={4}>
                    <DemoItem label={"Renseignez le rendez-vous travaux dans le champ ci-dessous"}>
                        <MobileDateTimePicker
                            ampm={false}
                            slotProps={{
                                textField: {
                                    fullWidth: true,
                                    InputProps: {
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <CalendarMonth/>
                                            </InputAdornment>
                                        ),
                                    },
                                    "data-test": "insurance-input-appointment"
                                }
                            }}
                            onAccept={handleAppointmentAccepted}
                        />
                    </DemoItem>
                </Box>
                <Box mt={4} px={2}>
                    <QuotationDetails interventionId={interventionId}/>
                </Box>
            </Body>
            <Footer>
                <Button
                    variant="contained"
                    size="small"
                    sx={{height: parameter.FOOTER_HEIGHT, borderRadius: 0}}
                    startIcon={<CheckCircle/>}
                    fullWidth
                    onClick={nextStep}
                    disabled={loading || !appointmentSelected}
                    data-test="insurance-button-next-step"
                >
                    Valider le rendez-vous travaux
                </Button>
            </Footer>

            <Link
                ref={callLink}
                visibility={"hidden"}
                href={`tel:${client.getPhoneMobile()}`}
                underline={"none"}
                color={"inherit"}
                data-test="insurance-link-call-client"
            />
        </>
    );
}
